// MODEL : instance of FieldFilter
//
define('app/filters/AbstractFieldFilterView',['require','glu/itemView','app/config/filterTypes','glu/util','./controls/FilterControls'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView'),
		FILTER_TYPES = require('app/config/filterTypes'),
		_ = require('glu/util'),
		FILTER_CONTROLS = require('./controls/FilterControls');


	return ItemView.extend({

		serializeData: function() {
			return this;
		},

		getFilterType: function() {
			if (!this.model.getOperator()) {
				return {
					inputMethod: 'add',
					label: ''
				};
			}
			return _.findWhere(FILTER_TYPES.field, {
				operator: this.model.getOperator(),
				type: this.model.type()
			});
		},

		getFilterControl: function() {
			return this.FILTER_CONTROLS[this.getFilterType().inputMethod];
		},

		createFilterControl: function() {
			var FilterControl = this.getFilterControl();
			return new FilterControl({
				model: this.model,
				className: 'filter-control',
				tagName: 'div'
			});
		},

		FILTER_CONTROLS: FILTER_CONTROLS
	});

});

